







































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Client from '@/models/Client';
import clients from '@/store/modules/clients';
import Config from '@/config';
import Loading from '@/components/Loading.vue';

@Component({
  components: {
    Loading,
  },
})
export default class FirstStep extends Vue {
  public name = 'first-step';
  @Prop() private msg!: string;
  @Prop() private client!: any;
  @Prop() private step!: any;

  private loading = false;
  private pendingClientsList: Client[] = [];
  private show = true;

  private errMessage = '';

  private form: any = {
    clientId: '',
    id: null,
    restaurantName: '',
    projectKey: '',
    alreadyExistingProject: false,
    deliverySetup: false,
    clientSetup: false,
    step: 1,
  };

  private async created() {
    if (this.client) {
      this.form.clientId = this.client.clientId;
      this.form.restaurantName = this.client.restaurantName;
      this.form.projectKey = this.client.projectKey;
      this.form.alreadyExistingProject = this.client.alreadyExistingProject;
      this.form.deliverySetup = this.client.deliverySetup;
      this.form.clientSetup = this.client.clientSetup;
    }
    this.form.step = this.step;

    await clients.getPendingClients();
    this.pendingClientsList = clients.getPendingClientsList;
    if (typeof this.$route.params.toSetUpPendingClientId !== 'undefined') {
      this.form.id = this.$route.params.toSetUpPendingClientId;
      this.updateFormFromPendingClient();
    }
  }

  private async onSubmit(event: any) {
    event.preventDefault();
    const validation = this.validateForm();
    if (validation === true) {
      try {
        this.loading = true;
        this.show = false;
        const client = await clients.firstStep(this.form);

        this.loading = false;
        this.show = true;
        this.$emit('created', client);
      } catch (err) {
        this.errMessage = err.message;
        this.loading = false;
        this.show = true;
        this.$emit('created', null);
      }
    } else {
      this.errMessage = validation;
    }
  }

  private updateFormFromPendingClient() {
    if (this.form.id === null) {
      this.form.restaurantName = '';
    } else {
      const selectedClient = this.pendingClientsList.filter(client => client.id === this.form.id);
      this.form.restaurantName = selectedClient[0]['restaurantName'];
    }
  }

  private validateForm() {
    if (this.form.clientId === '') {
      return 'Client ID cannot be empty';
    }

    if (RegExp('[^A-Za-z0-9_-]').test(this.form.clientId)) {
      return 'Client ID contains not allowed chars';
    }

    if (this.form.restaurantName === '') {
      return 'Restaurant Name cannot be empty';
    }

    if (this.form.projectKey.length < 3 || this.form.projectKey.length > 10) {
      return 'Project Key should contain from 3 to 10 chars';
    }

    if (RegExp('[^A-Z]').test(this.form.projectKey)) {
      return 'Project Key should contain only capital letters';
    }

    return true;
  }
}
